/**
 * Auto-ajuste de texto (§5.5): si el contenido no cabe, se reduce el font-size hasta
 * `maxLineas`; si aún no cabe, elipsis. Corre en el navegador del editor Y dentro de
 * Chromium antes del screenshot — la MISMA función, para que preview y PNG coincidan.
 */
export function ajustarTextos(raiz) {
    const nodos = raiz.querySelectorAll('[data-poster-texto="auto"]');
    for (const nodo of nodos) {
        const contenedor = nodo;
        const interno = contenedor.firstElementChild;
        if (!interno)
            continue;
        // SIEMPRE se parte del tamaño de diseño (data-tamano): el ajuste es idempotente y
        // re-crece cuando vuelve a caber. Nunca se lee el fontSize mutado de una corrida
        // anterior (ni el heredado del documento).
        let tamano = Number(contenedor.dataset['tamano']) || parseFloat(getComputedStyle(contenedor).fontSize);
        contenedor.style.fontSize = `${tamano}px`;
        interno.style.display = '';
        interno.style.overflow = '';
        interno.style.textOverflow = '';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- propiedad con prefijo
        interno.style.webkitLineClamp = '';
        const minimo = 9;
        let iteraciones = 0;
        while ((interno.scrollHeight > contenedor.clientHeight || interno.scrollWidth > contenedor.clientWidth) &&
            tamano > minimo &&
            iteraciones < 60) {
            tamano -= 2;
            contenedor.style.fontSize = `${tamano}px`;
            iteraciones += 1;
        }
        if (interno.scrollHeight > contenedor.clientHeight + 2) {
            // Aún no cabe: truncar con elipsis multi-línea.
            const maxLineas = Number(contenedor.dataset['maxLineas'] ?? '2');
            interno.style.display = '-webkit-box';
            interno.style.webkitLineClamp = String(maxLineas);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- propiedad con prefijo
            interno.style.webkitBoxOrient = 'vertical';
            interno.style.overflow = 'hidden';
            interno.style.textOverflow = 'ellipsis';
        }
    }
}
/** Fuente de la función como texto, para inyectarla en la página del renderer. */
export const AJUSTAR_TEXTOS_JS = `(${ajustarTextos.toString()})(document)`;
//# sourceMappingURL=ajustarTexto.js.map